import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Role } from '@core/models/role.enum';
import { coreSelectors } from '@core/store/core.selectors';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private store: Store
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.store.select(coreSelectors.currentUser).pipe(
      first(),
      map(currentUser => {
        let result;
        if (currentUser) {
          const roles = route.data.roles as Role[] || [];
          if (roles.length <= 0 || roles.some(r => r === currentUser.role)) {
            result = true;
          } else {
            result = false;
          }
        } else {
          result = false;
        }
        if (!result) {
          this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        }
        return result;
      })
    );
  }
}
